export default "__VITE_ASSET__v2yYapF1__"